export default __webpack_public_path__ + "static/media/comparable-empty-icon.285c09b6.svg";